(function () {
  'use strict';

  document.addEventListener('DOMContentLoaded', function () {
    var btn = document.getElementById('cn-blog-load-more');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var nextUrl = btn.getAttribute('data-next-url');
      if (!nextUrl) return;

      btn.disabled = true;
      btn.textContent = 'Loading\u2026';

      fetch(nextUrl)
        .then(function (res) {
          if (!res.ok) throw new Error('Failed to load');
          return res.text();
        })
        .then(function (html) {
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, 'text/html');
          var newCards = doc.querySelectorAll('#cn-blog-listing-grid .cn-blog-listing__card');
          var grid = document.getElementById('cn-blog-listing-grid');

          for (var i = 0; i < newCards.length; i++) {
            grid.appendChild(newCards[i]);
          }

          var newBtn = doc.getElementById('cn-blog-load-more');
          if (newBtn) {
            btn.setAttribute('data-next-url', newBtn.getAttribute('data-next-url'));
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-original-label') || 'Load More';
          } else {
            btn.parentElement.style.display = 'none';
          }
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = btn.getAttribute('data-original-label') || 'Load More';
        });
    });

    btn.setAttribute('data-original-label', btn.textContent.trim());
  });

})();
